import React, { FC } from 'react';
import SafeDealActionDesktopModal from './SafeDealActionDesktopModal';
import SafeDealActionMobileModal from './SafeDealActionMobileModal';
import { SafeDealActionCommonModalProps } from '../../../../../typings/safeDealActionCommonModalProps';

type SafeDealActionModalProps = SafeDealActionCommonModalProps & {
  desktop: boolean;
};

const SafeDealActionModal: FC<SafeDealActionModalProps> = ({ desktop, ...props }) =>
  desktop ? <SafeDealActionDesktopModal {...props} /> : <SafeDealActionMobileModal {...props} />;

export default SafeDealActionModal;
